import styled from 'styled-components'

import Image from '../Image'
import Placeholder from '../../atoms/Placeholder'

const CardImage = styled(Image).attrs({
  sizes: '(min-width: 1200px) 25vw, (min-width: 992px) 33vw, (min-width: 768px) 50vw, 100vw',
  imgixParams: { fit: 'crop', crop: 'focal', ar: '16:9' },
})`
  ${Placeholder} {
    width: 100%;
    height: 0;
    padding-top: 56.25%;
  }

  height: 100%;
`

export default CardImage
